import React from "react";
import GoodFirmsBadge from "./GoodFirmsBadge";

export default function AboutSection({
  content,
  heading,
  fullWidth = false,
}) {
  const text =
    content ||
    `We are the wizards who turn concepts into reality in a blink and cost-effectively. We enable you a platform as a service wherein startups can jumpstart their product development within weeks and hit the market at the right time with the least amount of money spent on product creation. We also provide our technology team as a service to help guide young brains with our technical experience so that startups can focus on GTM plans instead of running product development sprints. We provide an end-to-end backend platform-as-a-service along with integrating the same with a first-in-class front-end framework to fork out applications, be it web, mobile, IoT, and many more at lightning speed. Empower your vision while we handle the technological groundwork—let us bring your ideas to life- Orryworx.`;

  return (
    <div className="relative w-full mt-8 sm:mt-12 z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-20">
        <div className="bg-white rounded-[6px] px-8 sm:px-12 lg:px-16 py-14 shadow-2xl">

          {/* Heading */}
          <h2 className="text-4xl sm:text-5xl font-semibold text-center text-[#2f2f2f] mb-10">
            {heading || "Who We Are"}
          </h2>

          {fullWidth ? (
            <p className="text-[18px] sm:text-[20px] leading-[2.2rem] text-[#2f2f2f]">
              {text}
            </p>
          ) : (
            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1">
                <p className="text-[18px] sm:text-[20px] leading-[2.2rem] text-[#2f2f2f]">
                  {text}
                </p>
              </div>
              <div className="flex-shrink-0">
                <GoodFirmsBadge />
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
